import { useEffect } from 'react';
import { repairMojibake } from '../../utils/textEncoding';

const TEXT_ATTRIBUTES = ['alt', 'aria-label', 'placeholder', 'title', 'content'];

const isIgnored = (node) => {
  const parent = node.parentElement;
  return !parent || ['SCRIPT', 'STYLE', 'TEXTAREA'].includes(parent.tagName) || parent.isContentEditable;
};

const repairElement = (element) => {
  if (!(element instanceof Element) || ['SCRIPT', 'STYLE', 'TEXTAREA'].includes(element.tagName)) return;

  TEXT_ATTRIBUTES.forEach((attribute) => {
    const value = element.getAttribute(attribute);
    const repaired = repairMojibake(value);
    if (repaired !== value) element.setAttribute(attribute, repaired);
  });

  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  let node = walker.nextNode();
  while (node) {
    textNodes.push(node);
    node = walker.nextNode();
  }

  textNodes.forEach((textNode) => {
    if (isIgnored(textNode)) return;
    const repaired = repairMojibake(textNode.nodeValue);
    if (repaired !== textNode.nodeValue) textNode.nodeValue = repaired;
  });
};

/** Repairs legacy mis-encoded copy wherever it is rendered, including lazy-loaded pages. */
const TextEncodingRepair = () => {
  useEffect(() => {
    repairElement(document.head);
    repairElement(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData' && !isIgnored(mutation.target)) {
          const repaired = repairMojibake(mutation.target.nodeValue);
          if (repaired !== mutation.target.nodeValue) mutation.target.nodeValue = repaired;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) repairElement(node);
          if (node.nodeType === Node.TEXT_NODE && !isIgnored(node)) {
            const repaired = repairMojibake(node.nodeValue);
            if (repaired !== node.nodeValue) node.nodeValue = repaired;
          }
        });
      });
    });

    const observerOptions = { childList: true, characterData: true, subtree: true };
    observer.observe(document.head, observerOptions);
    observer.observe(document.body, observerOptions);
    return () => observer.disconnect();
  }, []);

  return null;
};

export default TextEncodingRepair;
